import type { SxProps, Theme } from '@mui/material/styles';

import { StyledStatusChip } from './StatusChip.styles';

interface StatusChipProps {
  label: string;
  bg?: string;
  color?: string;
  sx?: SxProps<Theme>;
  testId?: string;
}

export const StatusChip = ({ label, bg, color, sx, testId }: StatusChipProps) => (
  <StyledStatusChip
    label={label}
    statusbg={bg}
    statuscolor={color}
    variant="filled"
    sx={sx}
    data-testid={testId}
  />
);

export default StatusChip;
